import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookOpen, Trophy, Users, Calendar, MapPin, Target, Star, Flag } from 'lucide-react';

const GROUP_LETTERS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];

const FEATURED_TEAMS = [
  { slug: 'turkiye', name: 'Türkiye', icon: '🇹🇷' },
  { slug: 'brazil', name: 'Brazil', icon: '🇧🇷' },
  { slug: 'france', name: 'France', icon: '🇫🇷' },
  { slug: 'argentina', name: 'Argentina', icon: '🇦🇷' },
  { slug: 'england', name: 'England', icon: '🏴' },
  { slug: 'germany', name: 'Germany', icon: '🇩🇪' },
  { slug: 'spain', name: 'Spain', icon: '🇪🇸' },
  { slug: 'usa', name: 'USA', icon: '🇺🇸' },
];

export default function WCInternalLinks({ currentPage, lang }) {
  const { t } = useTranslation();
  const wcBase = lang === 'tr' ? `/${lang}/dunya-kupasi-2026` : `/${lang}/world-cup-2026`;
  const grpPath = lang === 'tr' ? 'grup' : 'group';
  const teamPath = lang === 'tr' ? 'takim' : 'team';
  const fixPath = lang === 'tr' ? 'fikstur' : 'fixtures';
  const trPath = lang === 'tr' ? 'turkiye' : 'turkey';

  return (
    <div className="bg-slate-900/40 border border-amber-500/10 rounded-xl p-5 mt-8" data-testid="wc-internal-links">
      <h3 className="text-sm font-bold text-amber-400 uppercase tracking-wider mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
        <Trophy className="w-4 h-4 inline mr-2" />{t('wc.breadcrumb')}
      </h3>

      <div className="flex flex-wrap gap-2 mb-4">
        {currentPage !== 'hub' && (
          <Link to={wcBase} className="text-xs bg-amber-500/10 hover:bg-amber-500/20 text-amber-300 px-3 py-1.5 rounded-lg border border-amber-500/20 transition-all">
            {t('wc.homepage')}
          </Link>
        )}
        {currentPage !== 'turkey' && (
          <Link to={`${wcBase}/${trPath}`} className="text-xs bg-red-500/10 hover:bg-red-500/20 text-red-300 px-3 py-1.5 rounded-lg border border-red-500/20 transition-all">
            {t('wc.turkey')}
          </Link>
        )}
        {currentPage !== 'fixtures' && (
          <Link to={`${wcBase}/${fixPath}`} className="text-xs bg-slate-800/60 hover:bg-slate-700/60 text-slate-300 px-3 py-1.5 rounded-lg border border-white/5 transition-all">
            <Calendar className="w-3 h-3 inline mr-1" />{t('wc.fixtures')}
          </Link>
        )}
      </div>

      <p className="text-[10px] text-slate-500 uppercase tracking-wider mb-2">{t('wc.groupsLabel')}</p>
      <div className="flex flex-wrap gap-1.5 mb-4">
        {GROUP_LETTERS.map(g => {
          const isActive = currentPage === `group-${g}`;
          return (
            <Link key={g} to={`${wcBase}/${grpPath}/${g}`}
              className={`text-xs font-semibold px-2.5 py-1 rounded-lg transition-all ${
                isActive ? 'bg-amber-500/20 text-amber-300 border border-amber-500/30'
                  : g === 'd' ? 'bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20'
                  : 'bg-slate-800/40 text-slate-500 hover:text-amber-300 border border-transparent hover:border-amber-500/20'
              }`}>
              {g.toUpperCase()}
            </Link>
          );
        })}
      </div>

      <p className="text-[10px] text-slate-500 uppercase tracking-wider mb-2">{t('wc.teamsLabel')}</p>
      <div className="flex flex-wrap gap-1.5">
        {FEATURED_TEAMS.filter(tm => currentPage !== `team-${tm.slug}`).map(tm => (
          <Link key={tm.slug} to={`${wcBase}/${teamPath}/${tm.slug}`}
            className="text-xs bg-slate-800/40 hover:bg-slate-700/40 text-slate-400 hover:text-amber-300 px-2.5 py-1 rounded-lg border border-transparent hover:border-amber-500/20 transition-all">
            {tm.icon} {tm.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
